export default "__VITE_ASSET__DwqKW9O3__"